/*
`reportWebVitals` é uma função utilizada em aplicações web para coletar e relatar métricas de desempenho do usuário final ao servidor ou a outras ferramentas de monitoramento. Essas métricas ajudam os desenvolvedores a medir e compreender o desempenho de suas aplicações web na vida real, permitindo que eles identifiquem e solucionem problemas de desempenho.

A função `reportWebVitals` é frequentemente usada em conjunto com a biblioteca de código aberto "web-vitals", que é desenvolvida pelo Google. A biblioteca "web-vitals" fornece uma maneira fácil de medir métricas de desempenho importantes, como tempo de carregamento da página, tempo de interatividade do usuário e muito mais.

Aqui estão algumas das métricas de desempenho que podem ser medidas e relatadas usando `reportWebVitals`:

1. **LCP (Largest Contentful Paint)**: Mede o tempo que leva para o maior elemento visível na janela de visualização ser carregado e renderizado na tela.

2. **FID (First Input Delay)**: Mede o tempo de resposta da página quando o usuário interage pela primeira vez com a página, como clicar em um botão ou link.

3. **CLS (Cumulative Layout Shift)**: Mede a quantidade de mudanças no layout da página que ocorrem após o carregamento inicial. Isso afeta a estabilidade visual da página.

4. **FCP (First Contentful Paint)**: Mede o tempo que leva para o primeiro elemento HTML ser renderizado na tela.

5. **TTFB (Time to First Byte)**: Mede o tempo que leva para o navegador receber a primeira resposta do servidor após fazer uma solicitação.

6. **TTFP (Time to First Paint)**: Mede o tempo que leva para o navegador começar a renderizar pixels na tela.

7. **TTC (Total Time Taken for Connection)**: Mede o tempo total necessário para estabelecer uma conexão com o servidor.

Ao relatar essas métricas de desempenho, os desenvolvedores podem identificar áreas de melhoria em suas aplicações web e tomar medidas para otimizar o desempenho, proporcionando uma melhor experiência ao usuário final. Isso é especialmente importante em um ambiente onde o desempenho é crítico para a retenção e a satisfação dos usuários.
*/


const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
